import React from 'react';
import { Icon } from '../../../../../../../../../ui-kit';
import { OptionsListElement } from '../../../Blocks/components/common/StyledEditables';

const Size = ({ iconSize }) =>
<OptionsListElement>
    <Icon
    name="sizeblank"
    color="white"
    size={iconSize} />

  </OptionsListElement>;


export default Size;